import React, { useState } from 'react';
import './CreateTableModal.css';

const PRESETS = [
  {
    id: 'micro', label: 'Micro NL', type: 'No-Limit', stakes: '$0.01 / $0.02',
    config: { smallBlind: 0.01, bigBlind: 0.02, ante: 0, minBuyIn: 0.40, maxBuyIn: 4.00, shortBuy: 0.20, allowThirdBlind: false, allowStraddles: false, maxStraddleCount: 0, raiseCap: null, handCap: null },
  },
  {
    id: 'low', label: 'Low NL', type: 'No-Limit', stakes: '$0.25 / $0.50',
    config: { smallBlind: 0.25, bigBlind: 0.50, ante: 0, minBuyIn: 10, maxBuyIn: 100, shortBuy: 5, allowThirdBlind: false, allowStraddles: false, maxStraddleCount: 0, raiseCap: null, handCap: null },
  },
  {
    id: 'mid', label: 'Standard NL', type: 'No-Limit', stakes: '$1 / $2',
    config: { smallBlind: 1, bigBlind: 2, ante: 0, minBuyIn: 40, maxBuyIn: 400, shortBuy: 20, allowThirdBlind: false, allowStraddles: true, maxStraddleCount: 2, raiseCap: null, handCap: null },
  },
  {
    id: 'high', label: 'High NL', type: 'No-Limit', stakes: '$5 / $10',
    config: { smallBlind: 5, bigBlind: 10, ante: 0, minBuyIn: 200, maxBuyIn: 2000, shortBuy: 100, allowThirdBlind: false, allowStraddles: false, maxStraddleCount: 0, raiseCap: null, handCap: null },
  },
  {
    id: 'pl', label: 'Pot-Limit', type: 'Pot-Limit', stakes: '$1 / $2',
    config: { smallBlind: 1, bigBlind: 2, ante: 0, minBuyIn: 40, maxBuyIn: 400, shortBuy: 20, allowThirdBlind: false, allowStraddles: false, maxStraddleCount: 0, raiseCap: null, handCap: null },
  },
  {
    id: 'cards', label: 'Card NL', type: 'No-Limit', stakes: '$1 / $2',
    config: { smallBlind: 1, bigBlind: 2, ante: 0, minBuyIn: 40, maxBuyIn: 400, shortBuy: 20, allowThirdBlind: false, allowStraddles: false, maxStraddleCount: 0, raiseCap: null, handCap: null, deckType: 'cards' },
  },
];

const BOT_OPTIONS = [
  { value: 0, label: 'No bots — human players only' },
  { value: 2, label: '2 bots' },
  { value: 4, label: '4 bots' },
];

export default function CreateTableModal({ onClose, onCreate }) {
  const [presetId,  setPresetId]  = useState('mid');
  const [tableName, setTableName] = useState('');
  const [botCount,  setBotCount]  = useState(2);

  const preset = PRESETS.find(p => p.id === presetId);

  const handleCreate = () => {
    onCreate({
      name:     tableName.trim() || preset.label,
      type:     preset.type,
      stakes:   preset.stakes,
      config:   preset.config,
      botCount,
    });
  };

  return (
    <div className="ctm-overlay" onClick={onClose}>
      <div className="ctm-modal" onClick={e => e.stopPropagation()}>
        <div className="ctm-header">
          <h2 className="ctm-title">Create Table</h2>
          <button className="ctm-close" onClick={onClose}>✕</button>
        </div>

        <div className="ctm-section">
          <label className="ctm-label">Table type</label>
          <div className="ctm-presets">
            {PRESETS.map(p => (
              <button
                key={p.id}
                className={`ctm-preset ${presetId === p.id ? 'selected' : ''}`}
                onClick={() => setPresetId(p.id)}
              >
                <span className="ctm-preset-label">{p.label}</span>
                <span className="ctm-preset-stakes">{p.stakes}</span>
                <span className={`type-badge ${{ 'No-Limit': 'nl', 'Pot-Limit': 'pl' }[p.type] ?? 'pl'}`}>{p.type}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="ctm-section">
          <label className="ctm-label" htmlFor="ctm-name">Table name <span className="ctm-optional">(optional)</span></label>
          <input
            id="ctm-name"
            className="ctm-input"
            type="text"
            maxLength={40}
            placeholder={preset?.label ?? ''}
            value={tableName}
            onChange={e => setTableName(e.target.value)}
          />
        </div>

        <div className="ctm-section">
          <label className="ctm-label">Bots</label>
          <div className="ctm-bot-options">
            {BOT_OPTIONS.map(o => (
              <label key={o.value} className={`ctm-radio ${botCount === o.value ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="botCount"
                  value={o.value}
                  checked={botCount === o.value}
                  onChange={() => setBotCount(o.value)}
                />
                {o.label}
              </label>
            ))}
          </div>
        </div>

        <div className="ctm-footer">
          <button className="ctm-cancel" onClick={onClose}>Cancel</button>
          <button className="ctm-create" onClick={handleCreate}>Create &amp; Go to Table</button>
        </div>
      </div>
    </div>
  );
}
